import React from 'react';

export default class Panel extends React.Component {

    constructor (props){
        super(props);
    }

    render = () =>  <div className="panel">
        { this.props.children }
    </div>
}